import { Fragment } from "react";

interface powerupAndCounterProps {
    img: string;
    title: string;
    desc: string;
    onClick?: any;
    counter?: number;
}

const PowerupAndCounter: React.FC<powerupAndCounterProps> = ({
    img,
    title,
    desc,
    counter = 0,
    onClick = null,
}) => {
    return (
        <div
            className="relative flex flex-col items-center justify-center flex-1 mx-1 my-1 text-center cursor-pointer"
            onClick={onClick}
        >
            <div className="w-20 h-20 rounded-full ">
                <img
                    src={img}
                    alt="powerup"
                    className="object-contain w-full h-full"
                />
            </div>
            <span className="text-base font-bold text-dark-purple">
                {title}
            </span>
            <span className="text-xs font-light text-dark-purple">{desc}</span>
            <span className="absolute top-0 px-2 py-1 text-xs font-bold text-white rounded-full right-2 bg-coral-red">
                {counter}
            </span>
        </div>
    );
};

interface powerupsDropdownProps {
    powerups: any[];
    onPowerupClick?: any;
}

const dummyPowerupCallback = (powerup: any) => {
    console.log("no powerup callback found!");
};

export const PowerupsDropdown: React.FC<powerupsDropdownProps> = ({
    powerups,
    onPowerupClick = dummyPowerupCallback,
    set,
}) => {
    const getPowerupCount = (key: string) => {
        for (const item of powerups) {
            if (item.type === key) {
                return item.count;
            }
        }
        return 0;
    };

    const getPowerup = (key: string) => {
        for (const item of powerups) {
            if (item.type === key) {
                return item;
            }
        }
        return { type: key };
    };
    return (
        <Fragment>
            <div className="absolute arrow-up left-10 top-1" />
            <div className="absolute left-0 z-20 flex flex-col p-4 mx-2 rounded-lg shadow-collection top-7 bg-smoke-gray">
                <div className="text-2xl font-bold text-dark-purple">
                    Powerups
                </div>
                <div className="flex flex-wrap">
                    {set?.type !== "practise_learn_practise" && (
                        <PowerupAndCounter
                            onClick={() =>
                                onPowerupClick(getPowerup("time_travel"))
                            }
                            img={"/assets/images/powerup-time-boost.png"}
                            title={"Time travel"}
                            desc={"Fills timer to 100%"}
                            counter={getPowerupCount("time_travel")}
                        />
                    )}
                    <PowerupAndCounter
                        onClick={() => onPowerupClick(getPowerup("50_50"))}
                        img={"/assets/images/powerup-50-50.png"}
                        title={"50:50"}
                        desc={"Eliminates 50% options"}
                        counter={getPowerupCount("50_50")}
                    />

                    {set?.type !== "practise_learn_practise" && (
                        <PowerupAndCounter
                            onClick={() =>
                                onPowerupClick(getPowerup("double_up"))
                            }
                            img={"/assets/images/powerup-points-x2.png"}
                            title={"Double up"}
                            desc={"Doubles the points"}
                            counter={getPowerupCount("double_up")}
                        />
                    )}
                </div>
            </div>
        </Fragment>
    );
};
